export default "__VITE_ASSET__B0HrGSlg__"